<template>
  <div class="step-indicator">
    <div
      class="indicate"
      :class="{
        'active': step === 1,
        'pointer': rightStep,
      }"
      @click="rightStep ? setModalStep('first_step') : null"
    />
    <div
      class="indicate"
      :class="{
        'active': step === 2,
        'pointer': rightStep,
      }"
      @click="step === 2 ? setModalStep('second_step') : null"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    step: {
      default: 1,
      type: Number,
    },
  },
  computed: {
    rightStep() {
      return this.step === 1 || this.step === 2;
    },
  },
  methods: {
    ...mapActions({
      setModalStep: 'modal/setModalStep',
    }),
  },
};
</script>
